import { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import api from '../../services/api'

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = String(reader.result || '')
      const b64 = result.includes(',') ? result.split(',')[1] : result
      resolve(b64)
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

/**
 * CRUD FIEL en Datos fiscales (solo edición de cliente existente).
 */
const FielClienteSection = ({ clientId }) => {
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [info, setInfo] = useState(null)
  const [cerFile, setCerFile] = useState(null)
  const [keyFile, setKeyFile] = useState(null)
  const [password, setPassword] = useState('')
  const [activo, setActivo] = useState(true)

  const load = async () => {
    setLoading(true)
    try {
      const { data } = await api.get(`/clients/clients/${clientId}/fiel/`)
      setInfo(data)
      setActivo(data.activo !== false)
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo cargar la FIEL')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (clientId) load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId])

  const handleSave = async () => {
    if (!cerFile || !keyFile || !password.trim()) {
      toast.error('Seleccione .cer, .key y capture la contraseña FIEL')
      return
    }
    setSaving(true)
    try {
      const certificado_fiel = await fileToBase64(cerFile)
      const llave_privada_fiel = await fileToBase64(keyFile)
      const { data } = await api.put(`/clients/clients/${clientId}/fiel/`, {
        certificado_fiel,
        llave_privada_fiel,
        password_fiel: password,
        activo,
      })
      setInfo(data)
      setCerFile(null)
      setKeyFile(null)
      setPassword('')
      toast.success('FIEL guardada correctamente')
    } catch (err) {
      const detail = err.response?.data
      const msg =
        typeof detail === 'string'
          ? detail
          : detail?.detail ||
            detail?.non_field_errors?.[0] ||
            Object.values(detail || {})?.[0]?.[0] ||
            'Error al guardar FIEL'
      toast.error(String(msg))
    } finally {
      setSaving(false)
    }
  }

  const handleDelete = async () => {
    if (!window.confirm('¿Eliminar la FIEL de este cliente?')) return
    setSaving(true)
    try {
      await api.delete(`/clients/clients/${clientId}/fiel/`)
      setInfo({ fiel_configurada: false, activo: false })
      toast.success('FIEL eliminada')
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo eliminar la FIEL')
    } finally {
      setSaving(false)
    }
  }

  if (loading) {
    return (
      <div className="py-3">
        <Spinner size="sm" animation="border" /> Cargando FIEL…
      </div>
    )
  }

  return (
    <>
      {info?.fiel_configurada ? (
        <Alert variant="success" className="mb-3">
          FIEL configurada. RFC certificado: <strong>{info.rfc_certificado || '—'}</strong>
          {info.vigente_hasta ? <> · Vigente hasta {info.vigente_hasta}</> : null}
        </Alert>
      ) : (
        <Alert variant="warning" className="mb-3">
          Sin FIEL configurada. Es requerida para la descarga masiva del SAT.
        </Alert>
      )}

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Certificado FIEL (.cer)</Form.Label>
            <Form.Control
              type="file"
              accept=".cer"
              onChange={(e) => setCerFile(e.target.files?.[0] || null)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Llave privada (.key)</Form.Label>
            <Form.Control
              type="file"
              accept=".key"
              onChange={(e) => setKeyFile(e.target.files?.[0] || null)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Contraseña FIEL</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
            />
          </Form.Group>
        </Col>
      </Row>
      <Form.Check
        type="switch"
        id="fiel-activo"
        label="FIEL activa para descarga automática"
        checked={activo}
        onChange={(e) => setActivo(e.target.checked)}
        className="mb-3"
      />
      <div className="d-flex gap-2">
        <Button variant="primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Guardando…' : 'Guardar FIEL'}
        </Button>
        {info?.fiel_configurada && (
          <Button variant="outline-danger" onClick={handleDelete} disabled={saving}>
            Eliminar FIEL
          </Button>
        )}
      </div>
    </>
  )
}

export default FielClienteSection
